import React, { useState } from "react";
import { Button, Card, Col, Row, Form, Alert, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import './AjouterClient.css';

export default function AjouterClient() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [step, setStep] = useState(1); // 1: Infos générales, 2: Identifiants, 3: Paramètres financiers
    const [formData, setFormData] = useState({
        // Étape 1 - Infos générales
        code_client: '',
        raison_sociale: '',
        type_client: 'entreprise', // 'entreprise', 'particulier'
        civilite: 'M.',
        nom: '',
        prenom: '',
        adresse: '',
        ville: '',
        code_postal: '',
        pays: 'Gabon',
        telephone: '',
        telephone2: '',
        email: '',
        site_web: '',
        
        // Étape 2 - Identifiants juridiques
        numero_compte: '',
        ice: '',
        patente: '',
        rc: '',
        identifiant_fiscal: '',
        cnss: '',
        forme_juridique: 'SARL',
        
        // Étape 3 - Paramètres financiers
        plafond_credit: 0,
        solde_initial: 0,
        mode_reglement_defaut: 'especes',
        delai_paiement: 30,
        condition_paiement: 'comptant',
        tarif_applique: 'standard',
        notes: ''
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validation de base
        if (!formData.raison_sociale) {
            setError("La raison sociale est obligatoire");
            return;
        }

        setLoading(true);
        setError("");
        setSuccess("");

        try {
            const token = localStorage.getItem("token");
            const response = await fetch(
                `https://sawd.julesferry-ga.com/api/clients.php`,
                {
                    method: 'POST',
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                }
            );

            const result = await response.json();

            if (response.ok && result.success) {
                setSuccess("Client créé avec succès !");
                setTimeout(() => {
                    navigate('/ventes/clients/liste');
                }, 2000);
            } else {
                setError(result.message || "Erreur lors de la création du client");
            }
        } catch (err) {
            setError("Erreur de connexion au serveur "+err);
        } finally {
            setLoading(false);
        }
    };

    const nextStep = () => {
        if (step === 1 && !formData.raison_sociale) {
            setError("La raison sociale est obligatoire");
            return;
        }
        setError("");
        setStep(step + 1);
    };

    const prevStep = () => {
        setError("");
        setStep(step - 1);
    };

    return (
        <React.Fragment>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                {/* En-tête */}
                <div className="d-md-flex align-items-center justify-content-between mb-4">
                    <div>
                        <ol className="breadcrumb fs-sm mb-1">
                            <li className="breadcrumb-item"><Link to="/dashboard">Tableau de bord</Link></li>
                            <li className="breadcrumb-item"><Link to="/ventes">Ventes</Link></li>
                            <li className="breadcrumb-item"><Link to="/ventes/clients/liste">Clients</Link></li>
                            <li className="breadcrumb-item active">Ajouter un client</li>
                        </ol>
                        <h4 className="main-title mb-0">Nouveau client</h4>
                    </div>
                </div>

                {/* Stepper */}
                <div className="stepper mb-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className={`step ${step >= 1 ? 'active' : ''} ${step > 1 ? 'completed' : ''}`}>
                            <div className="step-number">1</div>
                            <div className="step-label">Informations générales</div>
                        </div>
                        <div className="step-line"></div>
                        <div className={`step ${step >= 2 ? 'active' : ''} ${step > 2 ? 'completed' : ''}`}>
                            <div className="step-number">2</div>
                            <div className="step-label">Identifiants juridiques</div>
                        </div>
                        <div className="step-line"></div>
                        <div className={`step ${step >= 3 ? 'active' : ''}`}>
                            <div className="step-number">3</div>
                            <div className="step-label">Paramètres financiers</div>
                        </div>
                    </div>
                </div>

                <Row className="justify-content-center">
                    <Col xl="10">
                        <Card className="border-0 shadow-sm">
                            <Card.Body className="p-4">
                                {error && (
                                    <Alert variant="danger" onClose={() => setError("")} dismissible>
                                        <i className="ri-error-warning-line me-2"></i>
                                        {error}
                                    </Alert>
                                )}
                                {success && (
                                    <Alert variant="success">
                                        <i className="ri-checkbox-circle-line me-2"></i>
                                        {success}
                                    </Alert>
                                )}

                                <Form onSubmit={handleSubmit}>
                                    {/* Étape 1: Informations générales */}
                                    {step === 1 && (
                                        <div className="step-content">
                                            <h5 className="mb-4">Informations générales</h5>
                                            
                                            <Row className="g-3">
                                                <Col md="6">
    <Form.Group>
        <Form.Label>Type de client</Form.Label>
        <div className="d-flex gap-4 mt-2">
            <Form.Check
                type="radio"
                label="Entreprise"
                name="type_client"
                value="entreprise"
                checked={formData.type_client === 'entreprise'}
                onChange={handleChange}
                className="p-3 bg-light rounded-3 border"
                style={{ minWidth: '150px', cursor: 'pointer' }}
            />
            <Form.Check
                type="radio"
                label="Particulier"
                name="type_client"
                value="particulier"
                checked={formData.type_client === 'particulier'}
                onChange={handleChange}
                className="p-3 bg-light rounded-3 border"
                style={{ minWidth: '150px', cursor: 'pointer' }}
            />
        </div>
    </Form.Group>
</Col>
                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Code client <span className="text-secondary">(optionnel)</span></Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="code_client"
                                                            value={formData.code_client}
                                                            onChange={handleChange}
                                                            placeholder="Généré automatiquement si vide"
                                                        />
                                                        <Form.Text className="text-muted">
                                                            Laissez vide pour génération automatique
                                                        </Form.Text>
                                                    </Form.Group>
                                                </Col>

                                                {formData.type_client === 'entreprise' ? (
                                                    <>
                                                        <Col md="12">
                                                            <Form.Group>
                                                                <Form.Label>Raison sociale <span className="text-danger">*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="raison_sociale"
                                                                    value={formData.raison_sociale}
                                                                    onChange={handleChange}
                                                                    placeholder="Nom de l'entreprise"
                                                                    required
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md="4">
                                                            <Form.Group>
                                                                <Form.Label>Forme juridique</Form.Label>
                                                                <Form.Select
                                                                    name="forme_juridique"
                                                                    value={formData.forme_juridique}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="SARL">SARL</option>
                                                                    <option value="SA">SA</option>
                                                                    <option value="SAS">SAS</option>
                                                                    <option value="EI">Entreprise Individuelle</option>
                                                                    <option value="SNC">SNC</option>
                                                                    <option value="Association">Association</option>
                                                                    <option value="Autre">Autre</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Col md="2">
                                                            <Form.Group>
                                                                <Form.Label>Civilité</Form.Label>
                                                                <Form.Select
                                                                    name="civilite"
                                                                    value={formData.civilite}
                                                                    onChange={handleChange}
                                                                >
                                                                    <option value="M.">M.</option>
                                                                    <option value="Mme">Mme</option>
                                                                    <option value="Mlle">Mlle</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md="5">
                                                            <Form.Group>
                                                                <Form.Label>Nom</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="nom"
                                                                    value={formData.nom}
                                                                    onChange={handleChange}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col md="5">
                                                            <Form.Group>
                                                                <Form.Label>Prénom</Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="prenom"
                                                                    value={formData.prenom}
                                                                    onChange={handleChange}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </>
                                                )}

                                                <Col md="12">
                                                    <Form.Group>
                                                        <Form.Label>Adresse</Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={2}
                                                            name="adresse"
                                                            value={formData.adresse}
                                                            onChange={handleChange}
                                                            placeholder="Adresse complète"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="4">
                                                    <Form.Group>
                                                        <Form.Label>Ville</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="ville"
                                                            value={formData.ville}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="4">
                                                    <Form.Group>
                                                        <Form.Label>Code postal</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="code_postal"
                                                            value={formData.code_postal}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="4">
                                                    <Form.Group>
                                                        <Form.Label>Pays</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="pays"
                                                            value={formData.pays}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Téléphone</Form.Label>
                                                        <Form.Control
                                                            type="tel"
                                                            name="telephone"
                                                            value={formData.telephone}
                                                            onChange={handleChange}
                                                            placeholder="+212 XXX-XXXXXX"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Téléphone secondaire</Form.Label>
                                                        <Form.Control
                                                            type="tel"
                                                            name="telephone2"
                                                            value={formData.telephone2}
                                                            onChange={handleChange}
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Email</Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            name="email"
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                            placeholder="contact@entreprise.com"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Site web</Form.Label>
                                                        <Form.Control
                                                            type="url"
                                                            name="site_web"
                                                            value={formData.site_web}
                                                            onChange={handleChange}
                                                            placeholder="https://"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </div>
                                    )}

                                    {/* Étape 2: Identifiants juridiques */}
                                    {step === 2 && (
                                        <div className="step-content">
                                            <h5 className="mb-4">Identifiants juridiques</h5>
                                            
                                            <Row className="g-3">
                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Numéro de compte</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="numero_compte"
                                                            value={formData.numero_compte}
                                                            onChange={handleChange}
                                                            placeholder="N° de compte bancaire"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>ICE (Identifiant Commun des Entreprises)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="ice"
                                                            value={formData.ice}
                                                            onChange={handleChange}
                                                            placeholder="Numéro ICE"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Patente</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="patente"
                                                            value={formData.patente}
                                                            onChange={handleChange}
                                                            placeholder="Numéro de patente"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>RC (Registre de Commerce)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="rc"
                                                            value={formData.rc}
                                                            onChange={handleChange}
                                                            placeholder="Numéro RC"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Identifiant fiscal (IF)</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="identifiant_fiscal"
                                                            value={formData.identifiant_fiscal}
                                                            onChange={handleChange}
                                                            placeholder="Identifiant fiscal"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>CNSS</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="cnss"
                                                            value={formData.cnss}
                                                            onChange={handleChange}
                                                            placeholder="Numéro CNSS"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>

                                            <div className="mt-4 p-3 bg-light rounded">
                                                <i className="ri-information-line text-primary me-2"></i>
                                                <small>
                                                    Ces identifiants sont spécifiques aux entreprises gabonaise. 
                                                    Laissez vide si non applicable.
                                                </small>
                                            </div>
                                        </div>
                                    )}

                                    {/* Étape 3: Paramètres financiers */}
                                    {step === 3 && (
                                        <div className="step-content">
                                            <h5 className="mb-4">Paramètres financiers</h5>
                                            
                                            <Row className="g-3">
                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Plafond de crédit</Form.Label>
                                                        <div className="input-group">
                                                            <span className="input-group-text">DH</span>
                                                            <Form.Control
                                                                type="number"
                                                                step="0.01"
                                                                name="plafond_credit"
                                                                value={formData.plafond_credit}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        <Form.Text className="text-muted">
                                                            0 = pas de crédit autorisé
                                                        </Form.Text>
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Solde initial</Form.Label>
                                                        <div className="input-group">
                                                            <span className="input-group-text">DH</span>
                                                            <Form.Control
                                                                type="number"
                                                                step="0.01"
                                                                name="solde_initial"
                                                                value={formData.solde_initial}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Mode de règlement par défaut</Form.Label>
                                                        <Form.Select
                                                            name="mode_reglement_defaut"
                                                            value={formData.mode_reglement_defaut}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="especes">Espèces</option>
                                                            <option value="cheque">Chèque</option>
                                                            <option value="virement">Virement</option>
                                                            <option value="carte_bancaire">Carte bancaire</option>
                                                            <option value="traite">Traite</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Délai de paiement (jours)</Form.Label>
                                                        <Form.Control
                                                            type="number"
                                                            name="delai_paiement"
                                                            value={formData.delai_paiement}
                                                            onChange={handleChange}
                                                            min="0"
                                                            max="365"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Condition de paiement</Form.Label>
                                                        <Form.Select
                                                            name="condition_paiement"
                                                            value={formData.condition_paiement}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="comptant">Comptant</option>
                                                            <option value="30j">30 jours fin de mois</option>
                                                            <option value="60j">60 jours fin de mois</option>
                                                            <option value="acompte">Acompte + solde</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>

                                                <Col md="6">
                                                    <Form.Group>
                                                        <Form.Label>Tarif appliqué</Form.Label>
                                                        <Form.Select
                                                            name="tarif_applique"
                                                            value={formData.tarif_applique}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="standard">Tarif standard</option>
                                                            <option value="grossiste">Tarif grossiste</option>
                                                            <option value="premium">Tarif premium</option>
                                                            <option value="promo">Promotionnel</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>

                                                <Col md="12">
                                                    <Form.Group>
                                                        <Form.Label>Notes / Observations</Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={3}
                                                            name="notes"
                                                            value={formData.notes}
                                                            onChange={handleChange}
                                                            placeholder="Informations complémentaires..."
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </div>
                                    )}

                                    <hr className="my-4" />

                                    {/* Boutons de navigation */}
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            {step > 1 && (
                                                <Button variant="outline-secondary" onClick={prevStep}>
                                                    <i className="ri-arrow-left-line me-2"></i>
                                                    Étape précédente
                                                </Button>
                                            )}
                                        </div>
                                        <div className="d-flex gap-2">
                                            <Button 
                                                variant="secondary" 
                                                onClick={() => navigate('/ventes/clients/liste')}
                                            >
                                                Annuler
                                            </Button>
                                            {step < 3 ? (
                                                <Button variant="primary" onClick={nextStep}>
                                                    Étape suivante
                                                    <i className="ri-arrow-right-line ms-2"></i>
                                                </Button>
                                            ) : (
                                                <Button 
                                                    variant="success" 
                                                    type="submit"
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <>
                                                            <Spinner size="sm" className="me-2" />
                                                            Création en cours...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="ri-check-line me-2"></i>
                                                            Créer le client
                                                        </>
                                                    )}
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Footer />
            </div>
        </React.Fragment>
    );
}